/**
 * Email validation utility that avoids catastrophic backtracking
 * This replaces regex-based email validation to prevent ReDoS attacks
 */

/**
 * Validates if a string is a valid email address format
 * Uses string methods instead of regex to avoid catastrophic backtracking
 * 
 * @param email - The string to validate
 * @returns true if the email format is valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  // Check for basic email structure: local@domain.tld
  const atIndex = email.indexOf('@');
  if (atIndex <= 0 || atIndex === email.length - 1) {
    return false;
  }
  
  const localPart = email.substring(0, atIndex);
  const domainPart = email.substring(atIndex + 1);
  
  // Check local part (before @)
  if (localPart.length === 0 || localPart.includes(' ')) {
    return false;
  }
  
  // Check domain part (after @)
  const dotIndex = domainPart.lastIndexOf('.');
  if (dotIndex <= 0 || dotIndex === domainPart.length - 1) {
    return false;
  }
  
  const domain = domainPart.substring(0, dotIndex);
  const tld = domainPart.substring(dotIndex + 1);
  
  // Basic validation: domain and tld should not be empty and contain no spaces
  return domain.length > 0 && tld.length > 0 && 
         !domain.includes(' ') && !tld.includes(' ');
}
